/*
 * File: Modal.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 21, 2022 at 12:37 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: May 30, 2024 at 10:54 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Modal.styles';
import { Padding } from '../Padding';


/**
 * Component
 */

export const Modal = ({
	isOpen, variant, showOverlay, handleClose, showClose, className, children, useWrapper, clickOutsideClose
}) => (
	<S.ModalContainer isOpen={isOpen} showOverlay={showOverlay} className={isOpen ? 'show-modal' : undefined}>

		{/* Action Overlay */}
		{clickOutsideClose && <S.ActionOverlay onClick={() => { handleClose(); }} />}

		{/* Modal */}
		<S.Modal className={className} variant={variant}>

			{/* Close Button */}
			{showOverlay && showClose && <S.CloseButton icon={['fal', 'times']} size={1.1} onClick={() => { handleClose(); }} />}

			{/* Modal Content */}
			{useWrapper ? (
				<S.ModalWrapper>
					<Padding left right>
						{children}
					</Padding>
				</S.ModalWrapper>
			) : children}
		</S.Modal>
	</S.ModalContainer>
);


/**
 * Configuration
 */

Modal.displayName = 'Modal';
Modal.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	variant: PropTypes.oneOf(['standard', 'medium', 'large', 'full']),
	showOverlay: PropTypes.bool,
	isOpen: PropTypes.bool,
	showClose: PropTypes.bool,
	handleClose: PropTypes.func,
	className: PropTypes.string,
	useWrapper: PropTypes.bool,
	clickOutsideClose: PropTypes.bool
};
Modal.defaultProps = {
	children: null,
	variant: 'standard',
	showOverlay: true,
	isOpen: false,
	showClose: true,
	handleClose: null,
	className: null,
	useWrapper: false,
	clickOutsideClose: true
};
